import { UITypes } from "types"

import { FormattedPhoneNumber } from "components/table/columnComponents/PhoneNumber"

export const customersTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Email",
    type: "sort-search",
    name: "email",
  },
  {
    title: "Devices",
    type: "sort-search",
    name: "devices_count",
    size: "small",
  },
  {
    title: "Phone",
    type: "sort-search",
    name: "phone",
    cellComponent: FormattedPhoneNumber,
  },
  {
    title: "Full Name",
    type: "sort-search",
    name: "full_name",
  },
  {
    title: "Customer ID",
    type: "sort-search",
    name: "id",
    size: "middle",
  },
  {
    title: "Membership",
    type: "sort-search",
    name: "membership",
    size: "small",
  },
]
